// extracted by mini-css-extract-plugin
export var icons = "social-share-module--icons--2622a";
export var root = "social-share-module--root--28bbb";